module.exports = __webpack_public_path__ + "img/lr11rr1y1.4d667eb7.gif";